import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import Axios from 'axios';

import AuthConsumer from "./useAuth.jsx";
import Loader from "../libs/loader.jsx";
import Monday from "./useMonday.jsx";

import BackgroundCache from "../libs/backgroundCache.jsx";

export default function Login()
{
    const navigate = useNavigate();
    const auth = AuthConsumer();
    const { state } = useLocation();
    
    let loader = React.createRef();
    
    useEffect( () => {
        async function effect()
        {
            //console.log('Login');
            var monday_token = await Monday.getMondaySessionToken();
            
            var data = new FormData();
            data.append('token', monday_token);
            
            var subscription_ok = true;
            var subscription_ok = await Monday.checkMondaySubscription(loader);
            //console.log("Login: subscription_ok -> ", subscription_ok);
            
            var user = await Monday.getMondayUser();
            //console.log("user: ", user);
            
            var slug = await Monday.getMondayAccountSlug(loader);
            //console.log("Login: slug", slug);

            //subscription_ok=true;
            if(subscription_ok==false)
            {
                navigate("/subscription");
            }
            else
            {
            
                //check token and backend api access token
                Axios.post('/login', data )
                    .then(response => {
                        //console.log('login data', response);
                        if(response.data.auth==true)
                        {
                            auth.login(slug, user, monday_token, response.data.personal_token, response.data.personal_token_valid, response.data.tracket_token_valid, response.data.csrf_token).then(() => {
                                navigate(state?.path || "/");
                            });
                            
                            if( response.data.personal_token_valid===true )
                            {
                                Monday.setPersonalToken( response.data.personal_token );
                            }
                            
                            BackgroundCache.startCaching();
                        }
                    })
                    .catch(error => {
                        //console.error(error);
                        
                        if(error.response.status === 401 && error.response.data.message=='Unauthenticated.')
                        {
                            //console.log(window.location.href);
                            //redirect to oauth monday app page
                            window.location.href = 'https://auth.monday.com/oauth2/authorize?client_id=' + config.app_id + '&redirect_uri=' + window.location.protocol + '//' + window.location.hostname+'/register' + '&subdomain=' + slug;
                        }
                        else
                        {
                            console.log('error', error.response.data.error, error);
                        }
                    });
            }
            
        }
        
        effect();
    }, [])
    

    return (
        <Loader ref={loader} style={{ 'height': '100%' }}>
        </Loader>
    );
};
